import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import LanguageProvider from './containers/LanguageProvider';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import 'typeface-roboto'

import './index.css';

const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};

const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

if (isAndroid() && !isIOS()) {
  const statusBarHeight = window.innerHeight < window.innerWidth ? 0 : 25;

  if (window.visualViewport) {
    const paddingTop = Math.max(statusBarHeight, 0);
    if (paddingTop > 0) {
      const root = document.getElementById('root');
      if (root) {
        root.style.paddingTop = paddingTop + 'px';
      }
    }
  }
}

const theme = createTheme({
  typography: {
    fontFamily: [
      'Roboto',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#1890ff',
    },
    white: {
      main: '#fff',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </ThemeProvider>,
  document.getElementById('root')
);